import { render, staticRenderFns } from "./IcoMyDevelopmentPlan.vue?vue&type=template&id=b49612cc"
import script from "./IcoMyDevelopmentPlan.vue?vue&type=script&lang=js"
export * from "./IcoMyDevelopmentPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports